import { FormikProvider, getIn, useFormik } from "formik";
import { IRenter } from "../../../../../../../types/renter.type";
import { useReactivatePlan } from "./customHook/useReactivatePlan";
import { useEffect, useState } from "react";
import { reactivatePlan } from "../../../../../../../common/services/renters.api";
import { useToastContext } from "../../../../../../../common/components/ui/toast/toast.context";
import { saveVehicleRecords } from "../../../../../../../common/services/vehicles.api";
import { DateSubscriptionFormik } from "../../../../forms/fields/DateSubscriptionFormik";
import { AvailableVehiclesFieldFormik } from "../../../../forms/fields/AvailableVehiclesFieldFormik";
import VehicleBondingFlow from "../../../../../../../common/components/ui/registerVehilcePhotos/VehicleBondingFlow";
import * as Yup from "yup";

type ReactivatePlanProps = {
  data: IRenter;
};

const validationSchema = Yup.object().shape({
  subscriptionInitialDate: Yup.date().required("Data de início da assinatura é obrigatória"),
  vehicleId: Yup.string().required("Veículo é obrigatório"),
});

export default function ReactivatePlan(props: ReactivatePlanProps) {
  const { notifySuccess, notifyError } = useToastContext();
  const [, setIsSubmitting] = useState(false);

  let vehicleId;
  const {
    oldPlanName,
    unlinkDate,
    initialRegisters,
    renterId,
    contractData,
    initialDateSubscription,
    renterName,
    licensePlate,
  } = useReactivatePlan(props.data);
  const renter = props.data;

  const formik = useFormik({
    initialValues: {
      vehicleId,
      renterId: renterId,
      initialDateSubscription,
      registers: initialRegisters,
      subscriptionInitialDate: new Date(),
    },
    validationSchema,
    onSubmit: async () => {
    },
  });

  useEffect(() => {
    formik.setFieldValue("registers", initialRegisters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const vehicle = getIn(formik.values, "vehicle");
  const currentVehicleId = vehicle?._id || getIn(formik.values, "vehicleId");

  useEffect(() => {
    if (currentVehicleId && currentVehicleId !== formik.values.vehicleId) {
      formik.setFieldValue("vehicleId", currentVehicleId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentVehicleId]);

  const handleReactivate = async (data: {
    renterId: string;
    vehicleId: string;
    photos: Array<{ type: string; content: string }>;
  }) => {
    try {
      setIsSubmitting(true);

      const reactivatePlanData = {
        renterId: data.renterId,
        vehicleId: data.vehicleId,
        subscriptionInitialDate: formik.values.subscriptionInitialDate,
      };

      const result = await reactivatePlan(reactivatePlanData, data.renterId);

      if (!result.ok) {
        notifyError(result.message as string);
        return {
          ok: false,
          message: result.message as string,
        };
      }

      notifySuccess("Plano reativado com sucesso");

      return {
        ok: true,
        message: "Plano reativado com sucesso",
      };
    } catch (error) {
      notifyError("Erro ao reativar plano");
      return {
        ok: false,
        message: "Erro ao reativar plano",
      };
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <form>
      <FormikProvider value={formik}>
        {/* Campos específicos do ReactivatePlan */}
        <section aria-labelledby="old-plan-section" className="mb-4">
          <label className="font-semibold text-sm">Plano antigo do cliente</label>
          <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
            {oldPlanName}
          </p>
          <label className="font-semibold text-sm mt-2 block">
            Data em que a moto foi desvinculada
          </label>
          <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">
            {licensePlate} - {unlinkDate}
          </p>
        </section>

        <section aria-labelledby="new-plan-section" className="mb-4">
          <DateSubscriptionFormik className="" />
        </section>

        {/* Componente genérico */}
        <VehicleBondingFlow
          renterId={renterId}
          renterName={renterName}
          onSavePhotos={saveVehicleRecords}
          onBond={handleReactivate}
          showVehicleSelector={true}
          contractData={contractData}
          buttonLabel="Reativar Plano"
          showPhotosDeliveryWarning={true}
          vehicleSelectorComponent={
            <AvailableVehiclesFieldFormik
              listAll={false}
              companyId={renter.companyId}
              renterId={renterId}
              required={true}
            />
          }
        />
      </FormikProvider>
    </form>
  );
}
